import { paginationStyles } from "@insite/content-library/Widgets/MyLists/MyListsPagination";
import { BaseTheme } from "@insite/mobius/globals/baseTheme";
import breakpointMediaQueries from "@insite/mobius/utilities/breakpointMediaQueries";
import { css } from "styled-components";

paginationStyles.pagination = {
    cssOverrides: {
        pagination: css`
            margin: 0 !important;
            select {
                font-size: 15px !important;
            }
        `,
        perPageSelect: css`
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(
                    theme,
                    [
                        null,
                        null,
                        css`
                            width: 30%;
                        `,
                    ],
                    "max",
                )}
            > div {
                padding: 0;
                width: auto;
                label {
                    width: auto;
                    font-size: 12px;
                    padding-top: 11px;
                    padding-right: 0;
                    text-transform: uppercase;
                    & + div {
                        width: auto;
                        select {
                            padding-right: 30px !important;
                            border-width: 0 !important;
                            background-color: #f7f7f7 !important;
                        }
                    }
                }
            }
        `,
        linkList: css`
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(
                    theme,
                    [
                        null,
                        null,
                        css`
                            width: 70%;
                        `,
                    ],
                    "max",
                )}
            ul li {
                button {
                    max-width: 30px;
                    span {
                        font-size: 12px;
                    }
                    border: none;
                    > span {
                        color: #353432;
                        &:hover {
                            color: #0000ff !important;
                        }
                    }
                    background-color: #f7f7f7 !important;
                    width: 20px;
                    height: 20px;
                    padding: 0px;
                    &:hover {
                        background-color: #f7f7f7 !important;
                        color: #0000ff !important;
                        border: 0.5px solid #0000ff !important;
                    }
                }
            }
        `,
        currentButton: css`
            width: 20px;
            height: 20px;
            padding: 0px;
            color: #0000ff;
            background-color: #f7f7f7;
            border: 0.5px solid #0000ff;
            > span {
                color: #0000ff;
            }
            &:hover {
                background-color: #f7f7f7 !important;
                color: #0000ff !important;
                border: 0.5px solid #0000ff;
            }
        `,
    },
};
